declare const navigator: Navigator & {
  connection?: {
    type?: string;
    effectiveType?: string;
  };
};

export const createConnectionTypeLabel = () => {
  /**
   * https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/type
   *
   * "bluetooth", "cellular", "ethernet", "none", "wifi", "wimax", "other", "unknown"
   */
  const connectionType = navigator.connection?.type;
  /**
   * https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/effectiveType
   *
   * "slow-2g", "2g", "3g", "4g"
   */
  const effectiveType = navigator.connection?.effectiveType;

  if (!connectionType && !effectiveType) {
    return 'N/A';
  }

  if (!effectiveType) {
    return connectionType || 'N/A';
  }

  if (!connectionType) {
    return effectiveType;
  }

  return `${connectionType} (${effectiveType})`;
};
